import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { observer } from "mobx-react";
import { useEffect } from "react";
import { trackAnalyticsEvent } from "../../../../../../others/tracking.js";
import { useStores } from "../../../../../../store/stores.js";
import { formatAmount } from "../../../../../../utils/formatAmount.js";
import { formatLocaleDate } from "../../../../../../utils/formatLocaleDate.js";
import { __ } from "../../../../../../utils/i18n.js";
import { MATOMO_MASK } from "../../../../../../utils/matomoMask.js";
import { EmptyState } from "../../../emptyState.js";
import { AffiliatePanel } from "../affiliatePanel.js";
const receiptButtonSuffix = (index, total)=>total > 1 ? ` (#${index + 1})` : "";
const PayoutsPage = observer(()=>{
    const { accountV2Store: { session } } = useStores();
    const affiliate = session?.affiliate;
    useEffect(()=>{
        affiliate?.fetchPayouts();
    }, []);
    if (!affiliate) {
        return null;
    }
    const { isBusyPayouts, payouts } = affiliate;
    const { payoutThreshold } = affiliate.affiliate;
    const isEmpty = payouts.size === 0 && !isBusyPayouts;
    const payoutEntries = Array.from(payouts.values());
    return /*#__PURE__*/ _jsx(AffiliatePanel, {
        heading: __("Payouts"),
        subline: __("We pay commissions on the 15th of the following month if your balance is above your threshold (%s). Receipts for the last 24 months are listed below.", formatAmount({
            amount: payoutThreshold,
            currency: "EUR",
            taxTreatment: "net"
        })),
        children: isEmpty ? /*#__PURE__*/ _jsx(EmptyState, {
            heading: __("No payouts yet"),
            subline: __("Receipts will appear here after your first payout.")
        }) : /*#__PURE__*/ _jsx("div", {
            className: "rc-account-v2-affiliate-list",
            children: payoutEntries.map((payout)=>{
                const receipts = payout.receipts ?? [];
                return /*#__PURE__*/ _jsxs("div", {
                    className: "rc-account-v2-affiliate-row rc-account-v2-affiliate-row--payout",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "rc-account-v2-affiliate-row__info",
                            children: [
                                /*#__PURE__*/ _jsx("span", {
                                    className: "rc-account-v2-affiliate-row__meta-label",
                                    children: __("Invoice no.")
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "rc-account-v2-affiliate-row__name",
                                    ...MATOMO_MASK,
                                    children: `#${payout.id}`
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "rc-account-v2-affiliate-row__meta",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "rc-account-v2-affiliate-row__meta-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "rc-account-v2-affiliate-row__meta-label",
                                            children: __("Payout date")
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "rc-account-v2-affiliate-row__value",
                                            children: formatLocaleDate(payout.createdAt)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "rc-account-v2-affiliate-row__meta-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "rc-account-v2-affiliate-row__meta-label",
                                            children: __("Total")
                                        }),
                                        /*#__PURE__*/ _jsx("span", {
                                            className: "rc-account-v2-affiliate-row__amount",
                                            children: formatAmount({
                                                amount: payout.netTotal,
                                                currency: "EUR",
                                                taxTreatment: "net"
                                            })
                                        }),
                                        payout.vatTotal > 0 && /*#__PURE__*/ _jsx("span", {
                                            className: "rc-account-v2-affiliate-row__amount-sub",
                                            children: __("plus %s VAT", formatAmount({
                                                amount: payout.vatTotal,
                                                currency: "EUR"
                                            }))
                                        })
                                    ]
                                })
                            ]
                        }),
                        receipts.length > 0 && /*#__PURE__*/ _jsx("div", {
                            className: "rc-account-v2-affiliate-row__actions",
                            children: receipts.map((receipt, index)=>/*#__PURE__*/ _jsxs(Button, {
                                    icon: /*#__PURE__*/ _jsx(DownloadOutlined, {}),
                                    onClick: ()=>{
                                        trackAnalyticsEvent("affiliate_payout_receipt_downloaded", {
                                            ga: {
                                                event_category: "account",
                                                event_label: "Affiliate payout receipt downloaded"
                                            },
                                            matomo: {
                                                category: "account",
                                                name: "Affiliate payout receipt downloaded"
                                            }
                                        });
                                        window.open(receipt.downloadUrl, "_blank");
                                    },
                                    children: [
                                        __("Download"),
                                        receiptButtonSuffix(index, receipts.length)
                                    ]
                                }, index))
                        })
                    ]
                }, payout.id);
            })
        })
    });
});
export { PayoutsPage };
